import { initializeApp } from "firebase/app";
import {
  createUserWithEmailAndPassword,
  getAuth,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signOut,
  setPersistence,
  browserSessionPersistence,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Set up Firebase
const firebaseConfig = {
  apiKey: "AIzaSyA9HQMTLpoaFP2fWl9EQYRJpQGu1EizF3E",
  authDomain: "trustchainwallet-66521.firebaseapp.com",
  projectId: "trustchainwallet-66521",
  storageBucket: "trustchainwallet-66521.firebasestorage.app",
  messagingSenderId: "905326767150",
  appId: "1:905326767150:web:9396eb1a67196259dc03bf"
};

const app = initializeApp(firebaseConfig);

const auth = getAuth();
const db = getFirestore(app);

const storage = getStorage(app);

// Listen only for logged in state

export {
  app,
  auth,
  db,
  storage,
  onAuthStateChanged,
  signOut,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  browserSessionPersistence,
  setPersistence,
};
